<upp-guest-ticket-preview *ngIf="ShowTicket" uppDataid="guestwaiter-ticket-preview"
    [ticket]="ShowTicket"
    color="warning"
    (Done)="OnShowTicket(null)"
></upp-guest-ticket-preview>

<ng-container *ngIf="ShowTicket === null">
    <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'">
        <div class="body">
            <ion-card>
                <ion-icon color="warning" [name]="IsPayWait ? 'card-outline' : 'hand-right-outline'"></ion-icon>
                <ion-card-title color="warning">
                    {{ IsPayWait ? tr('@place_event_type_PP') : tr('@place_waiter_requested_title') }}
                </ion-card-title>
                <ion-card-content *ngIf="IsOnlineWait">
                    {{ tr('@pay_ticket_waiting_title') }}
                </ion-card-content>
                <ion-card-content *ngIf="!IsOnlineWait && IsPayWait && PayMethod === 'PAYCARD'">
                    {{ tr('@place_waiter_payment_pending_card') }}
                </ion-card-content>
                <ion-card-content *ngIf="!IsOnlineWait && IsPayWait && PayMethod === 'PAYCASH'">
                    {{ tr('@place_waiter_payment_pending_cash') }}
                </ion-card-content>
                <ion-card-content *ngIf="!IsOnlineWait && !IsPayWait && Elapsed">
                    {{ tr('@place_waiter_requested_elapsed', [ Elapsed ]) }}
                </ion-card-content>
            </ion-card>

            <ion-list class="ticketinfo" *ngIf="IsOnlineWait">
                <upp-guest-ticket-thumb *ngFor="let ticket of onlineTickets; trackBy: TicketTrack"
                    uppDataid="guestwaiter-show-ticket"
                    [ticket]="ticket"
                    mode="PENDING"
                    (Open)="OnShowTicket($event)">
                </upp-guest-ticket-thumb>
            </ion-list>

            <ion-list class="ticketinfo" *ngIf="!IsOnlineWait">
                <ng-container *ngFor="let request of TicketRequests; trackBy: RequestTrack">
                    <upp-guest-ticket-thumb *ngIf="request.ticket as ticket"
                        uppDataid="guestwaiter-show-ticket"
                        [ticket]="ticket"
                        mode="PENDING"
                        [reason]="request.reason === 'REFUND' ? 'REFUND' : null"
                        [amount]="request.reason === 'REFUND' ? request.amount : null"
                        (Open)="OnShowTicket($event)">
                    </upp-guest-ticket-thumb>
                </ng-container>
                <upp-guest-ticket-thumb *ngFor="let ticket of OrphanPendingPayTickets; trackBy: TicketTrack"
                    uppDataid="guestwaiter-show-ticket"
                    [ticket]="ticket"
                    mode="PENDING"
                    (Open)="OnShowTicket($event)">
                </upp-guest-ticket-thumb>
            </ion-list>

            <ng-container *ngIf="PayAmount">
                <ion-item class="action" lines="none">
                    <ng-container *ngIf="IsOnlineWait">
                        <ion-label>
                            {{ tr('@place_waiter_payment_pending_title') }}<br/>
                            <span class="small">{{ tr('@pay_ticket_waiting_title') }}</span>
                        </ion-label>
                        <ion-label class="amount" slot="end">
                            {{ PayAmount.Int }}<span class="decimal">,{{ PayAmount.Dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ng-container>
                    <ng-container *ngIf="!IsOnlineWait && PayAmount.Neg !== true">
                        <ion-label>
                            {{ tr('@place_waiter_payment_pending_title') }}<br/>
                            <span class="small" *ngIf="PayMethod === 'PAYCASH'">{{ tr('@place_waiter_payment_pending_cash') }}</span>
                            <span class="small" *ngIf="PayMethod === 'PAYCARD'">{{ tr('@place_waiter_payment_pending_card') }}</span>
                        </ion-label>
                        <ion-label class="amount" slot="end">
                            {{ PayAmount.Int }}<span class="decimal">,{{ PayAmount.Dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ng-container>
                    <ng-container *ngIf="!IsOnlineWait && PayAmount.Neg === true">
                        <ion-label>
                            {{ tr('@place_waiter_refund_pending_title') }}<br/>
                            <span class="small">{{ tr('@place_waiter_refund_pending_message') }}</span>
                        </ion-label>
                        <ion-label class="amount" slot="end">
                            {{ PayAmount.Int }}<span class="decimal">,{{ PayAmount.Dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ng-container>
                </ion-item>
            </ng-container>
            <p *ngIf="IsPayWait" class="wait-message">
                {{ tr('@place_waiter_requested_message_wait') }}
            </p>
            <p *ngIf="!IsPayWait">
                {{ tr('@place_waiter_requested_message_title') }}<br/>
                <span class="small">{{ tr('@place_waiter_requested_message_wait') }}</span>
            </p>
        </div>
        <div class="list-spacer"></div>

        <div class="form-buttons">
            <ion-button *ngIf="!IsOnlineWait" uppDataid="guestwaiter-cancel-button" color="warning" size="large" expand="block" [disabled]="!CanCancel" (click)="OnCancel()">
                {{ tr('@place_waiter_request_cancel') }}
            </ion-button>
            <ion-button uppDataid="guestwaiter-close-button" color="warning" size="large" expand="block" fill="clear" (click)="OnClose()">
                {{ tr('@place_waiter_request_close') }}
            </ion-button>
        </div>
    </upp-scrollable>
</ng-container>
